import SmallCard from './small-card';
export default SmallCard;